import React from 'react'
import { Typography } from '@mui/material'
import { Video, VideoData } from '@media-components'
import {
  SectionHeader,
  SectionHeaderData,
  SectionWrapper,
} from '@components/common'

export type VideoSectionData = {
  videoData: VideoData
  darkBg?: boolean
  compactView?: boolean
  sectionHeaderData?: SectionHeaderData
}

type VideoSectionProps = VideoSectionData & {
  showDivider?: 'top' | 'bottom'
  alternateSectionBg?: boolean
}

export function VideoSection({
  videoData,
  showDivider,
  compactView,
  sectionHeaderData,
  darkBg = false,
  alternateSectionBg = false,
}: VideoSectionProps) {
  return (
    <SectionWrapper
      showDivider={showDivider}
      flexCol={{ xs: '20px', md: '40px' }}
      alternateBg={darkBg}
      alternateSectionBg={alternateSectionBg}
    >
      <SectionHeader {...sectionHeaderData} darkBg={darkBg} />
      <Video
        {...videoData}
        csx={{
          wrapper: {
            width: '100%',
            height: 'auto',
            // Compact matches former 518px @ ~full desktop width; default is 16:9 (640px).
            aspectRatio: compactView ? '16 / 7.3' : '16 / 9',
          },
        }}
      />
    </SectionWrapper>
  )
}

export default VideoSection
